import { defineStore } from 'pinia';
import axios from 'axios';

export const useMetalsStore = defineStore('metals', {
    state: () => ({
        data: [],
        loading: false,
        error: null,
        metalsObj: [
            {
                name: 'Медь',
                color: "linear-gradient(180deg, #feb673 0%, #523317 100%)",
                borderColor:'solid 2px #523317',
                weight: 0,
                percent: 0,
                tableName: 'Cu'
            },
            {
                name: 'Серебро',
                color: "linear-gradient(180deg, #C0C0C0 0%, #5A5A5A 100%)",
                borderColor:'solid 2px #5A5A5A',
                weight: 0,
                percent: 0,
                tableName: 'Ag'
            },
            {
                name: 'Золото',
                color: "linear-gradient(180deg, #FFEE90 0%, #7c6e02 100%)",
                borderColor:'solid 2px #C7B000',
                weight: 0,
                percent: 0,
                tableName: 'Au'
            },
            {
                name: 'Платина',
                color: "linear-gradient(180deg, #E5E4E2 0%, #7F7E7D 100%)",
                borderColor:'solid 2px #7F7E7D',
                weight: 0,
                percent: 0,
                tableName: 'Pt'
            },
            {
                name: 'Палладий',
                color: "linear-gradient(180deg, #EDEDED 0%, #4B4B4B 100%)",
                borderColor:'solid 2px #4B4B4B',
                weight: 0,
                percent: 0,
                tableName: 'Pl'
            },
            {
                name: 'Никель',
                color: "linear-gradient(180deg, #B5B6B5 0%, #505050 100%)",
                borderColor:'solid 2px #505050',
                weight: 0,
                percent: 0,
                tableName: 'Ni'
            },
            {
                name: 'Цинк',
                color: "linear-gradient(180deg, #FFFFFF 20%, #505050 100%)",
                borderColor:'solid 2px #505050',
                weight: 0,
                percent: 0,
                tableName: 'Zn'
            },
            {
                name: 'Покупная лигатура',
                color: "#5e5e81",
                weight: 0,
                percent: 0,
                tableName: 'lig'
            },
            {
                name: 'Кадмий',
                color: "linear-gradient(180deg, #C8C8C8 20%, #222222 100%)",
                borderColor:'solid 2px #222222',
                weight: 0,
                percent: 0,
                tableName: 'Cd'
            },
        ]
    }),
    actions: {
        async fetchData(date) {
            this.loading = true
            this.error = null
            try {
                const response = await axios.get(
                    '/api/metals',
                    // 'http://localhost:3000/api/metals',
                    {
                        params: {
                            date
                        },
                        headers: {
                            'X-API-KEY': process.env.VUE_APP_API_KEY,
                        }
                    }
                )

                this.data = response.data
            } catch (err) {
                this.error = 'Ошибка при получении данныхw'
                console.error(err)
            } finally {
                this.loading = false;
            }
        },
    },
    getters: {
        metals: (state) => state.data.length
    },
});
